module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"No results":"Keine Ergebnisse"}}')
  delete Component.options._Ctor
}
